import stars from "../assets/images/stars.jpg";

function SuggestionsPage() {
  // const handleAddSuggestion = () => {
  // navigate('/contactUs');
  //   };

  // const handleViewSuggestions = () => {
  // navigate('/contactUs');
  // };
  return (
    <div>
      {/* Hero section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="">Workspace solutions for all businesses</h1>
          <p>
            AirArrange provides flexible, scalable workplace solutions to help
            your business adapt and grow.
          </p>
          <div className="hero-buttons">
            <button className="primary-button flex flex-row justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
              Suggestions
            </button>
          </div>
        </div>
        <div className="hero-image">
          <img src={stars} alt="Workspace workspace" />
        </div>
      </section>
      {/* Hero section end */}
      {/* Suggestions section */}
      <div>show suggestions</div>
    </div>
  );
}

export default SuggestionsPage;
